import React from "react";
import Lab from "./Lab";
import QuestionPap from "./QuestionPap";
import Theory from "./Theory";

const QnAPage = () => {
  return (
    <div>
      <QuestionPap />
    </div>
  );
};

export default QnAPage;
